module.exports = "<p>\n  departament works!\n</p>\n"